/*
    描述 ：实体资源管理模块公共方法
    创建人：李珊 
    创建时间：2019-10-30
*/
import { Injectable } from '@angular/core';
import { RefFileObjectService } from 'src/app/librarys/serves/public/ref-file-object.service';
import { DictionaryService } from '../../../../librarys/serves/public/dictionary.service';
import { KmsEnum } from '../kms-enum';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
declare var ol: any;

@Injectable({
    providedIn: 'root'
})
export class InstanceModuleService {
    constructor(
        private jwt: SwJwtService,
        private fileService: RefFileObjectService,
        private dicService: DictionaryService
    ) { }

    /*
         * 获取时间中的年月日
         * @param key      待获取的属性名
         * @param dateStr  时间字符串：××××/××/××
    */
    getYearOrMonthOrDay(key, dateStr) {
        let data;
        if (!dateStr) {
            data = {
                year: '',
                month: '',
                day: ''
            }
        } else {
            const dateArr = dateStr.split('/');
            const len = dateArr.length;
            data = {
                year: len > 0 ? dateArr[0] : '',
                month: len > 1 ? dateArr[1] : '',
                day: len > 2 ? dateArr[2] : ''
            }
        }
        return data[key];
    }

    /*
         * 根据年月日判断当前时间是否合法
         * @param year   年份取值
         * @param month  年份取值
         * @param day    天取值
    */
    validateTime(year, month, day) {
        let res = {
            timeStr: '',
            isValid: true
        };
        if (year && month && day) {
            res.timeStr = year + '/' + month + '/' + day;
        }
        if (year && month && !day) {
            res.timeStr = year + '/' + month;
        }
        if (year && !month && !day) {
            res.timeStr = year;
        }
        if (!year && !month && !day) {
            res.timeStr = '';
        }
        if (year && !month && day) {
            res.timeStr = year + '/ /' + day;
            res.isValid = false;
        }
        if (!year && !month && day) {
            res.timeStr = ' / /' + day;
            res.isValid = false;
        }
        if (!year && month && !day) {
            res.timeStr = ' /' + month + '/ ';
            res.isValid = false;
        }
        if (!year && month && day) {
            res.timeStr = ' /' + month + '/' + day;
            res.isValid = false;
        }
        return res;
    }

    // 字段名下划线分隔转化为驼峰命名
    transformKeyName(str) {
        const arr = str.split('_');
        let str1 = '';
        for (let i = 0; i < arr.length; i++) {
            if (i > 0) {
                const first = arr[i].substring(0, 1).toUpperCase();
                const second = arr[i].substring(1);
                arr[i] = first + second;
            }
            str1 += arr[i];
        }
        return str1;
    }

    /*
         * 获取区域图的格式
         * @param url        原始图片路径
    */
    getImgFormat(url) {
        const pathArr = url.split('/');
        const arr = pathArr[pathArr.length - 2].split('.');
        return arr[arr.length - 1].toLowerCase();
    }

    /*
         * 根据字典查看文字信息(针对表单信息中的下拉框类型的字段)
         * @param dicArr        当前字典的所有选项数据
         * @param dicValueStr   已选择的字典值序列（逗号隔开的字符串）
    */
    getDictionaryName(dicArr, dicValueStr) {
        let dicValueArr: any;
        let datas = [];
        if (dicValueStr) {
            dicValueArr = dicValueStr.split(',');
            for (let i = 0; i < dicArr.length; i++) {
                for (let j = 0; j < dicValueArr.length; j++) {
                    if (dicArr[i].id == dicValueArr[j]) {
                        datas.push(dicArr[i].text)
                    }
                }
            }
            if (datas.toString()) {
                return datas.toString();
            } else {
                return '无';
            }
        }
    }

    /*
         * 文件上传成功后保存业务id并与文件信息关联
         * @param fileList     待添加的文件数据
         * @param relationId   关联的业务id
         * @param code         文件策略
    */
    saveFile(fileList, relationId, code) {
        let addList = [];
        fileList.forEach(item => {
            let info: any = {};
            info.fileInfoId = item.fileInfoId;
            info.sort = item.sort;
            if (item.fileObjectId != undefined && item.fileObjectId != null && item.fileObjectId != "") {
                info.fileObjectId = item.fileObjectId;
            }
            addList.push(info);
        });
        if (addList.length > 0) {
            this.fileService.save(relationId, code, addList).subscribe();
        }
    }

    /*
         * 删除某个文件后一并删除文件信息记录
         * @param fileList   待删除的文件数据
    */
    delFile(fileList) {
        if (fileList.length) {
            this.fileService.delete(fileList).subscribe();
        }
    }

    // 获取当前坐标
    mapPointCurrent(point) {
        if (point) {
            let convWkt, geo, coordArr;
            convWkt = new ol.format.WKT();
            geo = convWkt.readGeometry(point);
            coordArr = geo.flatCoordinates;
            return coordArr;
        }
    }

    // 地图坐标转换方法
    pointConversion(point) {
        if (point) {
            let convWkt, geo, coordArr;
            convWkt = new ol.format.WKT();
            geo = convWkt.readGeometry(point);
            coordArr = geo.flatCoordinates;
            return ol.proj.transform(coordArr, 'EPSG:3857', 'EPSG:4326');
        }
    }

    /*
         * 自动创建表单
         * @param baseInfoConfig   表单字段数据
         * @param addOrUpdate      表单编辑/表单新增
         * @param data             表单值数据
         * @param validators       表单自带验证器
         * @param lengthValidator  自定义字段长度验证器
         * @param numberValidator  自定义数值验证器 
         * @param isOtherInfo      当前是否为实体其他信息表单（生平、流转、修复等）true:实体其他信息表单; false:实体基本信息表单
    */
    autoCreateForm(datas) {
        let group = {};
        for (let i = 0; i < datas.length; i++) {
            console.log(datas);
            let attribute = datas[i];
            
            // 当输入类型为下拉框时，获取下拉选项数组
            if (attribute.fieldType == '下拉框' && attribute.dictionryCode) {
                attribute['options'] = this.dicService.getDictionaryValueOrName(attribute.dictionryCode);
            }
        }
        return group;
    }

    /*
         * 根据输入年份和月份判断每个月有多少天
         * @param path   文件路径
    */
   getDayDatas(year, month) {
        let day = [];
        switch (month) {
            case '1':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '2':
                let years = year % 4;
                if (years == 0) {
                    day = new Array(29).fill('').map( (item, index) => index+1);
                } else {
                    day = new Array(28).fill('').map( (item, index) => index+1);
                }
            break;

            case '3':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '5':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '7':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '8':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '10':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            case '12':
                day = new Array(31).fill('').map( (item, index) => index+1);
            break;

            default:
                day = new Array(30).fill('').map( (item, index) => index+1);
        }

        return day;
   }

   /**
    * 转化文件后缀
    * 将doc 改成pdf
    * 将xslx改成html
  * @ignore
  */
  fileSuffixConversion(filePath){
    let fileSuffix = filePath.split('.');
    switch(fileSuffix[fileSuffix.length-1].toLocaleLowerCase()){
      case "docx" : fileSuffix[fileSuffix.length-1] = "pdf";  break;
      case "doc"  : fileSuffix[fileSuffix.length-1] = "pdf"; break;
      case "xls"  : fileSuffix[fileSuffix.length-1] = "html";break;
      case "xlsx" : fileSuffix[fileSuffix.length-1] = "html";  break;
    }
    let url ="";
    fileSuffix.forEach(path => {
      url +=path+"."
    });
    return url.substring(0,url.length-1)
  }

  // 生成32位编码
  uuid2() {
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 32; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; 
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); 
    s[8] = s[13] = s[18] = s[23];
    var uuid = s.join("");
    return uuid;
  }

    // 任意生成一种颜色
    generateRandomRGBA() {
        const r = Math.floor(Math.random() * 256);
        const g = Math.floor(Math.random() * 256);
        const b = Math.floor(Math.random() * 256);
        let randomInt = Math.floor(Math.random() * 3);
        let arr = [0.3, 0.35, 0.4]
        const a = arr[randomInt];
        return {
            color: `rgb(${r}, ${g}, ${b})`,
            bgColor: `rgba(${r}, ${g}, ${b}, ${a})`
        };
    }

    // 按照新旧项目区分资源类型选项
    getResourceTypeOptions() {
        // 判断当前知识库兼容状态
        let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
        const isCompatibleMode = kgDbInfo ? kgDbInfo.isCompatibleMode : null;
        let arr = [];
        if (isCompatibleMode) {
            arr = [...KmsEnum.oldFileTypes];
        }else{
            arr = [...KmsEnum.fileTypes];
        }
        return JSON.parse(JSON.stringify(arr));
    }

    // 根据资源的文件类型获取缩略图
    getResourceThumbnail(item,fileTypeOptions){
        // 根据文件类型获取缩略图
        let fileSuffix = item.fileSuffix ? item.fileSuffix : this.getFileSuffix(item.materialCategory, item.filePath);
        fileSuffix = fileSuffix.toLowerCase();
        // 图片
        if (item.materialCategory == fileTypeOptions[2].id) {
          if (item.fileThumbnail) {
            item["src"] = environment.staticFileUrl + item.fileThumbnail;
          } else if (item.filePath) {
            item["src"] = environment.staticFileUrl + item.filePath;
          } else {
            item["src"] = "assets/Images/files/img.png";
          }
        }
        // 音频
        else if (item.materialCategory == fileTypeOptions[3].id) {
          item["src"] = "assets/Images/files/audio.png";
        }
        // 视频
        else if (item.materialCategory == fileTypeOptions[4].id) {
          item["src"] = "assets/Images/files/video.png";
        }
        // 文档
        else if (item.materialCategory == fileTypeOptions[1].id) {
          if (fileSuffix == 'pdf') {
            item["src"] = "assets/Images/files/pdf.png";
          } else if (fileSuffix == 'doc' || fileSuffix == 'docx') {
            item["src"] = "assets/Images/files/doc.png";
          } else if (fileSuffix == 'xls' || fileSuffix == 'xlsx') {
            item["src"] = "assets/Images/files/xls.png";
          } else if (fileSuffix == 'txt') {
            item["src"] = "assets/Images/files/txt.png";
          } else {
            item["src"] = "assets/Images/files/document.png";
          }
        }
        // 链接
        else if (item.materialCategory && item.materialCategory.indexOf('KGS_LINKDATA') > -1) {
          if (item.fileThumbnail) {
            item["src"] = environment.staticFileUrl + item.fileThumbnail;
          } else{
            item["src"] = "assets/Images/files/link.png";
          }
        } else {
          item["src"] = "assets/Images/files/empty.png";
        }
        return item;
    }

    // 获取文件格式 例如：jpg
    getFileSuffix(fileType, filePath) {
        if (!fileType || fileType.indexOf('KGS_LINKDATA') > -1) {
            return '无';
        } else {
            if (filePath) {
                const arr = filePath.split('.');
                return arr.length > 0 ? arr[arr.length - 1] : '无';
            } else {
                return '无';
            }
        }
    }
}
